import styled from 'styled-components';

export const ItemCardWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  align-items: baseline;
  padding-top: 4px;
`;
